import { render, staticRenderFns } from "./RatingPreview.vue?vue&type=template&id=2a8d28d7&"
import script from "./RatingPreview.vue?vue&type=script&lang=js&"
export * from "./RatingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports